t = require('views/internal/teacup-with-helpers')('card_detail_add_button')

module.exports = t.renderable ({ klass }) ->
  classes =
    'card-detail-item-add-button': true
    'dark-hover': true
  classes[klass] = true
  t.a { class: t.classify(classes) }, ->
    t.icon 'add'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_add_button.coffee